<template>
 <div class="app-container">
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini" style="width: 100%;">
         <div class="formItemBox">
              <el-form-item label="签章编码:" prop="signatureCode">
                <el-input placeholder="" v-model="searchFrom.signatureCode"></el-input>
              </el-form-item>
              <el-form-item label="备案编号:" prop="signatureNo">
                <el-input  placeholder="" v-model="searchFrom.signatureNo"></el-input>
              </el-form-item>
              <!-- <el-form-item label="用章场景:" prop="useScene">
              <el-select v-model="searchFrom.useScene" placeholder="全部">
                <el-option  label="全部" value="" ></el-option>
                <el-option  label="虚捆提货" value="1" ></el-option>
                <el-option  label="虚捆转货" value="2" ></el-option>
                <el-option  label="实捆提货" value="3" ></el-option>
                <el-option  label="实捆转货" value="4" ></el-option>
                <el-option  label="合同签订" value="4" ></el-option>
              </el-select>
              </el-form-item> -->
              <el-form-item label="用章场景:" prop="useScene">
                    <el-select v-model="searchFrom.useScene"  placeholder="请选择">
                      <el-option v-for="val in yzcj" :label="val.name" :value="val.name" :key="val.id"></el-option>
                    </el-select>
                </el-form-item>
               <el-form-item label="申请时间:" prop="createTime">
                <el-date-picker
                  v-model="searchFrom.createTimes"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
        </div>
        <div class="searchBtnBox">
              <el-form-item>
                  <el-button type="primary" @click="searchFn">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="applyClick">申请签章</el-button>
                </el-form-item>
            </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border  class="tableComent">
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" @click="lookFN(scope.row)">查看</el-button>
              <el-button type="text" size="mini" @click="delFn(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="signatureCode"  min-width="200" :formatter="emptyFn" label="签章编码"></el-table-column>
        <el-table-column prop="signatureNo"  min-width="200" :formatter="emptyFn" label="备案号"></el-table-column>
        <el-table-column property="signatureType" label="签章关键字" min-width="150" :formatter="emptyFn"></el-table-column>
        <el-table-column property="useScene" label="用章场景" min-width="200" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="createUserName"  min-width="130" :formatter="emptyFn" label="申请人"></el-table-column>
        <el-table-column prop="createTime"  min-width="200" :formatter="dateTimeFormat" label="申请时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
     <el-dialog  title="申请签章"  :visible.sync="SQMark" width="480px" class="detail"  :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form :inline="true"  :model="SQFrom" ref="SQFrom" :rules="rules" class="demo-form-inline jiaoyan" label-width="190px" size="mini">
        <div class="inpBox">
            <div style="margin: 28px 0;">
                <el-form-item label="企业名称:" prop="tenantName">
                 <span>{{SQFrom.tenantName}}</span>
                </el-form-item>
                <el-form-item label="统一社会信用代码:" prop="tenantTaxpayerNumber">
                 <span>{{SQFrom.tenantTaxpayerNumber}}</span>
                </el-form-item>
                <el-form-item label="申请人:" prop="userName">
                 <span>{{SQFrom.userName}}</span>
                </el-form-item>
                <el-form-item label="申请人联系电话:" prop="mobile">
                 <span>{{SQFrom.mobile}}</span>
                </el-form-item>
                 <el-form-item label="签章关键字:" class="jiage" prop="signatureType" >
                  <el-input  placeholder="" maxlength="8" v-model="SQFrom.signatureType" ></el-input>
                </el-form-item>
                <el-form-item label="备案号:" class="jiage" prop="signatureNo" >
                  <el-input  placeholder="" v-model="SQFrom.signatureNo"  maxlength="20"></el-input>
                </el-form-item>
               <img class="applySignatureimg" src="../../../assets/images/applySignature.png" alt />
                <el-form-item label="用章场景:" prop="useScene">
                    <el-select v-model="SQFrom.useScene" multiple placeholder="请选择">
                      <!-- <el-option  label="请选择" value="" ></el-option>
                      <el-option  label="虚捆提货" value="1" ></el-option>
                      <el-option  label="虚捆转货" value="2" ></el-option>
                      <el-option  label="实捆提货" value="3" ></el-option>
                      <el-option  label="实捆转货" value="4" ></el-option> -->
                      <el-option v-for="val in yzcj" :label="val.name" :value="val.name" :key="val.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="验证码:" prop="code" class="jiage" >
                 <el-input  placeholder="" v-number-input.float="0" maxlength=""  v-model.trim="SQFrom.code" style="width:163px;"></el-input>
                 <el-button  size='mini' v-if="isShowGetCode2"   type="primary" @click="codeClick2" class="danwei1">获取验证码</el-button>
                 <span v-else class="identiCode1" >{{ countdown2 }}s后可重试</span>
                </el-form-item>
             </div>
              <span class="xieyiBigBox">
                  <el-checkbox v-model="SQFrom.checked"></el-checkbox>
                  <span style="font-size:14px;">&nbsp;&nbsp;我同意<span class="xieyi"  target="_blank" @click="xieyiFN" >&nbsp;《电子签章授权委托书》</span></span>
                </span>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="SQMark = false">取消</el-button>
        <el-button type="primary" @click="SQsave()">确定</el-button>
      </span>
   </el-dialog>
   <el-dialog  title="查看签章"  :visible.sync="seeQuXiaoClick" width="320px"   :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
    <div class="imgBox" style="margin-left: 25px">
        <el-image
            :src="signatureUrl"
            style="width: 230px; height: 230px">
        </el-image>
    </div>
    <span slot="footer" class="dialog-footer">
        <el-button @click="seeQuXiaoClick = false" type="primary">关闭</el-button>
      </span>
    </el-dialog>
     <el-dialog  title="授权委托书"  :visible.sync="shouquanClick" width="610px"   :close-on-click-modal="false" @close="closeDialog1" :close-on-press-escape="false" center>
    <div  style="margin-left: 25px">
      <h1 style="text-align:center;font-size:22px">电子签章授权委托书</h1>
      <p>甲方：中物（北京）物流信息服务有限公司</p>
      <p>乙方：{{this.SQFrom.tenantName}}</p>
      <p style="margin-top:30px"> 鉴于乙方同意入驻甲方平台，现针对乙方电子签章的使用签订如下协议：</p>
      <span style="line-height:30px">&nbsp; &nbsp; &nbsp; &nbsp; 一、乙方委托甲方向“E签宝”平台申请电子签章，申请签章的费用由甲方承担。<br>
      &nbsp; &nbsp; &nbsp; &nbsp; 二、上述电子签章由甲方保存以供乙方使用甲方平台期间的电子签章。<br>
      &nbsp; &nbsp; &nbsp; &nbsp; 三、乙方授权甲方使用乙方电子签章的范围：乙方使用甲方平台办理的全部提货、转货业务中需加盖乙方电子签章的相关文件，甲方加盖电子签章生成的实时用章记录乙方可随时查阅，如使用范围发生变更，双方可另行签订补充协议。<br>
      &nbsp; &nbsp; &nbsp; &nbsp; 四、乙方每次加盖电子签章前，默认同意当前协议，即视为乙方同意甲方加盖电子签章。<br>
      &nbsp; &nbsp; &nbsp; &nbsp; 五、在授权范围内，甲方加盖电子签章均视为乙方知晓并认可，所产生的一切法律后果均由乙方承担。</span>
    </div>
    <span slot="footer" class="dialog-footer">
        <el-button @click="shouquanClick = false" type="primary">关闭</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import { signatureApplySmsCheck, // 获取验证码
  signatureApplyAdd, // 确定
  signatureApplyList, // 列表
  signatureApplyDetail, // 查看
  signatureApplyDelete // 删除
} from '@/api/common-signature'
export default {
  data () {
    return {
    //   statusFormat (row, column, cellValue) {
    //   let newArr = []
    //   let arr = cellValue.split(',')
    //   console.log(arr);
    //   // let arr = cellValue
    //   for (let i = 0; i < arr.length; i++) {
    //     if (arr[i] == '1') {
    //       newArr.push('虚捆提货')
    //     } else if (arr[i] == '2') {
    //       newArr.push('虚捆转货')
    //     } else if (arr[i] == '3') {
    //       newArr.push('实捆提货')
    //     } else if (arr[i] == '4') {
    //       newArr.push('实捆转货')
    //     } else if (arr[i] == '5') {
    //       newArr.push('合同签订')
    //     }
    //   }
    //   return newArr.toString()
    // },
      shouquanClick: false,
      signatureUrl: '',
      seeQuXiaoClick: false,
      yzcj: [
        { name: '虚捆提货', id: 1 },
        { name: '虚捆转货', id: 2 },
        { name: '实捆提货', id: 3 },
        { name: '实捆转货', id: 4 },
        { name: '合同签章', id: 5 }
      ],
      // checked: false,
      isShowGetCode2: true,
      countdown2: 60,
      timer2: '',
      options: [],
      zjList: [],
      SQFrom: {
        checked: false
      },
      SQMark: false,
      rules: {
        signatureType: [
          { required: true, message: '请输入签章关键字 ', trigger: 'blur' }
        ],
        useScene: [
          { required: true, message: '请选择用章场景', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      dialogVisible: false,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      loading: false,
      goodTypes: [],
      btnFlg: [],
      btnIdArr: ['004P003B000', '004P003B001', '004P003B002']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/systemSetup/address')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 168) + 'px'
  },
  methods: {
    xieyiFN () {
      this.shouquanClick = true
    },
    // 获取验证码
    codeClick2 () {
      this.countDown2()
      this.isShowGetCode2 = false
      signatureApplySmsCheck({
        mobile: this.SQFrom.mobile // 动态获取手机号
      }).then(res => {
      }).catch(err => {
        message.error(err.message)
      })
    },
    countDown2 () {
      const self = this
      this.timer2 = setInterval(() => {
        self.countdown2--
        if (self.countdown2 === 0) {
          clearInterval(self.timer2)
          self.countdown2 = 60
          self.isShowGetCode2 = true
        }
      }, 1000)
    },
    SQsave () {
      if (!this.SQFrom.checked) {
        this.$message.error('请勾选电子签章授权委托书')
      } else {
        this.$refs.SQFrom.validate((valid) => {
          if (valid) {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            signatureApplyAdd({
              signatureType: this.SQFrom.signatureType,
              signatureNo: this.SQFrom.signatureNo,
              useScene: this.SQFrom.useScene.toString(),
              code: this.SQFrom.code
            }).then(res => {
              loading.close()
              this.$message({
                message: '成功',
                type: 'success'
              })
              this.SQMark = false
              this.isShowGetCode2 = true
              this.countdown2 = 60
              clearInterval(this.timer2)
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        })
      }
    },
    // 删除
    delFn (row) {
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        signatureApplyDelete({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 申请签章
    applyClick () {
      this.SQMark = true
      this.$nextTick(() => {
        this.$refs['SQFrom'].clearValidate()
      })
      this.$set(this.SQFrom, 'tenantName', localStorage.getItem('tenantName'))
      this.$set(this.SQFrom, 'tenantTaxpayerNumber', localStorage.getItem('tenantTaxpayerNumber'))
      this.$set(this.SQFrom, 'userName', localStorage.getItem('userName'))
      this.$set(this.SQFrom, 'mobile', localStorage.getItem('mobile'))
    },
    // 查看
    lookFN (row) {
      this.seeQuXiaoClick = true
      // console.log(row);
      this.signatureUrl = row.signatureUrl
      // console.log(this.signatureUrl);
      signatureApplyDetail({ id: row.id }).then(res => {

      })
    },
    // 查选
    searchFn () {
      // if (this.searchFrom.billNo) { this.searchFrom.billNos = this.searchFrom.billNo.split(/[(\r\n)\r\n]+/) } else {
      //   this.searchFrom.billNos = ''
      // }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      signatureApplyList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null
      }
    },
    closeDialog () {
      this.isShowGetCode2 = true
      this.countdown2 = 60
      clearInterval(this.timer2)
      this.SQFrom = {
        checked: false
      }
    },
    closeDialog1 () {

    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
  width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}

.jiage .el-form-item__content {
  position: relative;
  .identiCode1 {
    position: absolute;
    right: 14px;
    color: #409eff;
  }
  .danwei1 {
    position: absolute;
    right: 14px;
    color: white;
    padding: 7px 4px;
  }
}
 .xieyiBigBox{
      position: relative;
      top: 10px;
      left: 26%;
    }
    .xieyi{
      color: #409EFF;
      cursor: pointer;
    }
    a{
      text-decoration:none;
    }
    .applySignatureimg {
      margin-left: 80px;
    }

</style>
